import { Box, Button, Icon, Paper, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link, NavLink, useParams, useRouteMatch } from "react-router-dom";

import { getHeadOrgByIdRequest } from "../../HeadOrgsApiActions";

import AppBreadCrumb from "../../../../components/AppBreadCrumb/AppBreadCrumb";
import { APP_URLS } from "../../../../utilities/constants";
import { getUserInfo } from "../../../../utilities/storage";
import OrganizationList from "../../../Organizations/components/OrganizationsList/OrganizationsList";
import { useStyles } from "./styles";

/**
 * function to get message for activation dialog
 * @param org: org details
 * @param classes: classes from css
 * @returns {JSX.Element}
 * @constructor
 */

const HeadOrgProfile = ({ history, getHeadOrgByIdRequest, headOrg }) => {
  const classes = useStyles();
  const role = getUserInfo().Roles[0].name;
  const params = useParams();
  const match = useRouteMatch();

  const currentUrlPath = match.path.split(":")[0];

  useEffect(() => {
    getHeadOrgByIdRequest(params.id).then((res) => {});
  }, [params.id, getHeadOrgByIdRequest, history.location.state?.reload]);

  const breadCrumbDataForOrgProfilePage = [
    {
      icon: "business",
      name: "Head Organizations",
      path: APP_URLS.HEADORGS,
    },
    {
      name: `${headOrg ? `${headOrg.ownerName}` : ""}`,
      path: `${APP_URLS.HEADORGS}/${params.id}`,
    },
  ];

  /**
   * function to get breadcrumb data for current url
   */
  const getBreadcrumbData = () => {
    return breadCrumbDataForOrgProfilePage;
  };

  /**
   * function to toggle activation
   */

  return (
    <Box className={classes.outerContainer}>
      <AppBreadCrumb>
        {getBreadcrumbData(currentUrlPath).map((crumb, index) => (
          <Box
            key={index}
            component={NavLink}
            exact
            to={{
              pathname: crumb.path,
              state: {},
            }}
            className={classes.breadcrumbItem}
            activeClassName={classes.activeBreadcrumbItem}
          >
            {crumb.icon && (
              <Icon className={classes.breadcrumpIcon}>{crumb.icon}</Icon>
            )}
            <Box className={classes.breadcrumpLabel}>{crumb.name}</Box>
          </Box>
        ))}
      </AppBreadCrumb>

      <Box mt={3}>
        {headOrg && (
          <>
            <Box>
              <Box component={Paper} className={classes.profileContainer}>
                <Box className={classes.profileContentContainer}>
                  <Box className={classes.profileTextContainer}>
                    <Typography
                      classes={{
                        root: classes.orgNameText,
                      }}
                    >
                      {headOrg.ownerName}
                    </Typography>
                    <Typography
                      classes={{
                        root: classes.orgDescText,
                      }}
                    >
                      {headOrg.desc}
                    </Typography>

                    <Box className={classes.editDetailsButtonContainer}>
                      <Button
                        variant="contained"
                        color="primary"
                        disableElevation={true}
                        startIcon={<Icon>edit</Icon>}
                        component={Link}
                        to={{
                          pathname: `${match.path.split(":")[0]}edit/${
                            params.id
                          }`,
                        }}
                        classes={{ root: classes.profileButton }}
                      >
                        Edit Details
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box component={Paper} className={classes.tabsContainer}>
                <OrganizationList history={history} headOrgId={headOrg.id} />
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    headOrg: state.headOrgs.headOrg,
  };
};

const mapDispatchToProp = (dispatch) => {
  return {
    getHeadOrgByIdRequest: (id) => {
      return dispatch(getHeadOrgByIdRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProp)(HeadOrgProfile);
